import React from 'react';
import GenericError from '../components/ShoppingCart/GenericError';
import { useSelector } from 'react-redux';
import useTranslate from '../hooks/useTranslation';
import { KeyValue } from '../types/common.types';
import { BTL_ERROR_CODES } from '../constants/common';
import {
  springDPromotionsPageUrl,
  btlWhatsAppContactLink
} from '../config/links';
import { ORDER } from '../constants';

interface RootState {
  promotions: KeyValue;
  order: KeyValue;
}

export const BtlErrorPage = ({ data }) => {
  const { t } = useTranslate();

  const { promotions, order } = useSelector((state: RootState) => {
    return {
      promotions: state.promotions,
      order: state.order
    };
  });

  const promotionNotEligibleModel = {
    title: t('BTL_PROMOTION_NOT_ELIGIBLE_TITLE'),
    errorText: t('BTL_PROMOTION_NOT_ELIGIBLE_MESSAGE'),
    secondaryButtonText: t('BTL_PROMOTIONS_NOT_ELIGIBLE_BTN'),
    onSecondaryClick: () => window.location.replace(springDPromotionsPageUrl)
  };

  const promotionEndedModel = {
    title: t('BTL_PROMOTION_ENDED_TITLE'),
    errorText: t('BTL_PROMOTION_ENDED_MESSAGE'),
    secondaryButtonText: t('BTL_CAMPIGN_BROWSE_OFFERS'),
    onSecondaryClick: () => window.location.replace(springDPromotionsPageUrl)
  };

  const genericErrorModel = {
    title: t('BTL_GENERIC_ERROR_TITLE'),
    errorText: t('BTL_GENERIC_ERROR_DESCRIPTION'),
    secondaryButtonText: t('BACK_TO_HOME_CTA_TEXT'),
    onSecondaryClick: () => window.location.replace('/')
  };

  const unablePromoModel = {
    title: t('UNABLE_BTL_PROMOTION_TITLE'),
    errorText: t('UNABLE_BTL_PROMOTION_DESCRIPTION'),
    secondaryButtonText: t('CHAT_WITH_US'),
    onSecondaryClick: () => window.location.replace(btlWhatsAppContactLink)
  };

  const eshopApiFailure = promotions?.btlOfferError;
  const btlOfferDataWithSuccess = promotions?.btlCampignErrorDetail;
  const eShopErrorResponse = btlOfferDataWithSuccess?.error;
  let errorProps;
  if (eshopApiFailure) {
    errorProps = genericErrorModel;
  } else if (eShopErrorResponse && eShopErrorResponse?.message) {
    const eshopErrorMessage = eShopErrorResponse?.message;
    if (eshopErrorMessage.includes(BTL_ERROR_CODES.PROMOTION_ENDED)) {
      errorProps = promotionEndedModel;
    } else if (
      eshopErrorMessage.includes(BTL_ERROR_CODES.PROMOTION_NOT_ELIGIBLE)
    ) {
      errorProps = promotionNotEligibleModel;
    } else {
      errorProps = genericErrorModel;
    }
  } else if (ORDER.BTL_ORDER_ERRORS.includes(order?.error?.errorMsg)) {
    errorProps = unablePromoModel;
  } else {
    errorProps = genericErrorModel;
  }

  return <GenericError {...errorProps} />;
};

export default BtlErrorPage;
